import { FullWidthLayout } from '@/layouts'
import * as Styled from './legalPolicies.stlye'
import { Typography, useTheme } from '@cellectenergy/cellect-react-components'
import { styled } from '@mui/material/styles'

const CustomTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.corporateColors.primary.white,
}))

const PolicyLink = styled('a')(({ theme }) => ({
  color: theme.palette.common.corporateColors.primary.white,
  display: 'inline',
  font: 'inherit',
  textDecoration: 'underline',
  textUnderlineOffset: '0.125rem',
}))

export const LegalScreen = () => {
  const theme = useTheme()

  return (
    <FullWidthLayout id="free-trial" bgColor={theme.palette.common.corporateColors.primary.midNightBlue}>
      <Styled.LegalContainer>
        <Styled.BoxContent>
          <CustomTypography variant="headline-medium" fontWeight={500}>
            Legal Notice
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Who we are
          </CustomTypography>
          <CustomTypography variant="body-medium">
            CELLECT ENERGY SL, (hereinafter &quot;Cellect&quot;) is the owner of the Web Site{' '}
            <PolicyLink href="https://cellectenergy.com/">https://cellectenergy.com/</PolicyLink> (hereinafter the
            &quot;Web Site&quot;). Cellect is a commercial company of Spanish nationality with registered office at
            Josep Tarradellas, 8-10, 4-4, 08029 Barcelona, Spain and is registered in the Mercantile Registry of
            Barcelona, Volume 48045, Folio 148, Page B-570524 with VAT Number B67724062.
          </CustomTypography>
          <CustomTypography variant="body-medium">Cellect can be reached at:</CustomTypography>
          <CustomTypography variant="body-medium">
            E-mail: <PolicyLink href="mailto:privacy@cellectenergy.com">privacy@cellectenergy.com</PolicyLink>
          </CustomTypography>
          <CustomTypography variant="body-medium">Phone: +34 931 260 211</CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Object
          </CustomTypography>
          <CustomTypography variant="body-medium">
            By accessing and using the Website you acquire the status of &quot;User&quot;, which implies full acceptance
            of all the provisions of this Legal Notice and the rest of the &quot;Legal Texts&quot; including this Legal
            Notice, the Terms and Conditions, the Privacy Policy and the Cookies Policy.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            This Legal Notice regulates the access, navigation and use of this Web Site, without prejudice that Cellect
            reserves the right to modify the presentation, configuration and content of the same, as well as the
            conditions required for its access and/or use. The access and use of the contents of the Web Site after the
            entry into force of its modifications or changes implies the acceptance of the same.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            This Legal Notice is part of Cellect and reserves the right to modify the terms and conditions stipulated
            herein, in whole or in part, by publishing any changes in the same form in which they appear in this Legal
            Notice or through any type of communication addressed to users.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Use of the Website
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The User agrees to make proper, diligent and lawful use of the Website and, in particular (i) not to use the
            Website for illicit and/or illegitimate purposes; or illegally (ii) not to use the Website to the detriment
            of Cellect&apos;s interests (iii) not to use the Website with the purpose of causing damage, inefficiencies,
            interruptions, saturation, or analogous defects in the functionality of the Website; including the
            transmission of malware, viruses or similar programs to disseminate or publish offensive, racist,
            denigrating or pornographic content that could cause discomfort to people; (iv) not to break the security
            measures established by Cellect; (v) not to use the Web Site for advertising purposes, such as sending spam
            or other similar ways.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The User shall be liable for the breach of any of the aforementioned misuse of the Web Site, as well as for
            any loss or damage suffered by Cellect due to a direct or indirect misuse of the Web Site. For these
            purposes, Cellect may exercise all the judicial and extrajudicial actions it deems appropriate.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Privacy
          </CustomTypography>
          <CustomTypography variant="body-medium">
            All data provided to Cellect through the Website will be treated by Cellect as Data Controller, respecting
            the confidentiality, integrity and availability of personal data, in accordance with the Privacy Policy.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Cookies
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The use of cookies on the Website will be regulated in the Cookies Policy.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Commercial communications
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Provided that the User gives his express consent, or in case of having a contract in force with the User,
            Cellect will send commercial communications to keep the User updated on all the news, as well as any type of
            information about Cellect or the services it provides that may be of interest to him/her.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Cellect shall send such commercial communications for as long as the User maintains his/her consent to do so
            or for as long as the contractual relationship with the User is in force. However, if the User does not wish
            to receive any more commercial communications, he/she may withdraw his/her consent through the form provided
            in the commercial communications, or, if applicable, by sending an e-mail to{' '}
            <PolicyLink href="mailto:privacy@cellectenergy.com">privacy@cellectenergy.com</PolicyLink>
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Links
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The Web Site may contain links to other web pages in order to complement the services offered to the user.
            Cellect is not the owner of these web pages, so it is not responsible for their contents or for the damages
            that the use of them may cause to the user.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            If the user of the Web Site accesses such web pages and the services they offer, Cellect shall remain
            outside any kind of relationship that may be established between the user and the owners of such web pages
            or any third parties related to them.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Likewise, the owner of a web page in which it intends to insert a link to the Web Site must obtain prior
            authorization from Cellect.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Cellect shall not be responsible for the contents of those web pages in which there is a link to the Web
            Site and shall remain outside the relations that may be established between the owners of such web pages and
            the users of the Web Site.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Industrial and intellectual property
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The intellectual and industrial property rights incorporated in the Web Site, the graphic design and
            computer codes, as well as the distinctive signs and trademarks, text, images, videos (hereinafter the
            &quot;Content&quot;) displayed are the property of Cellect. The User shall use the services of the Web Site
            respecting such ownership and the use of the services shall not grant any rights in relation to the Content
            of the Web Site.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Any use of the Content for which Cellect has not expressly authorized, whether directly or indirectly for
            profit or not, including the downloading, storage, transmission, public disclosure, distribution,
            reproduction or transformation, in whole or in part, of such content is expressly prohibited, so Cellect may
            exercise all judicial and extrajudicial actions it deems appropriate to any breach of its rights.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Responsibility
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Cellect has made every effort to ensure that the information on the Web Site is accurate and up to date.
            However, Cellect makes no warranties or representations as to the accuracy and currency of the contents of
            the Web Site. Cellect is not responsible for any errors or omissions in the contents of the Web Site and
            reserves the right to change such contents at any time without notice.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The commercial relations between Cellect and the Users are governed by other general conditions or specific
            agreements, so that the contents of the Web Site do not prevail over such conditions or agreements and the
            Users cannot condition the commercial policy that Cellect decides to adopt at any time.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Cellect is not responsible for any errors or failures in the operation of the Web Site, whether intrinsic or
            due to the characteristics and limitations of the Internet. The user assumes any risk arising from the use
            of the Internet, including the possible transmission of computer viruses. Cellect does not guarantee the
            uninterrupted operation of the services of the Web Site and shall not be liable for any damages that may
            arise from the interruption of the services. In particular, Cellect shall not be liable in circumstances of
            force majeure such as fires, strikes and power outages or any other unforeseeable or unavoidable events, as
            well as the improper use of the Web Site by the User in accordance with the provisions of this legal notice.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            In any case, Cellect shall only be liable for damages that were foreseen or could have been foreseen at the
            time of the use of the Website by the user, and which are a direct and necessary consequence of a grossly
            negligent breach of substantial contractual obligations.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The fact that the Web Site describes or presents certain services does not imply a commitment by Cellect
            that such services will be available to the user.
          </CustomTypography>
          <CustomTypography variant="body-medium">
            The exclusion of liability and warranties described in this section shall apply to Cellect as well as to its
            directors, officers, employees and representatives.
          </CustomTypography>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <CustomTypography variant="title-large" fontWeight={500}>
            Modifications
          </CustomTypography>
          <CustomTypography variant="body-medium">
            Cellect reserves the right to modify this Legal Notice at any time. Changes or updates to the Legal Notice,
            as well as to the Terms and Conditions, Privacy Policy and/or Cookies Policy will be explicitly notified to
            the User through a notice on the Website.
          </CustomTypography>
          <CustomTypography variant="body-medium">Last modification: April 2026</CustomTypography>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  )
}
